import { render, staticRenderFns } from "./LicentieKopen.vue?vue&type=template&id=3fd357be&scoped=true"
import script from "./LicentieKopen.vue?vue&type=script&lang=js"
export * from "./LicentieKopen.vue?vue&type=script&lang=js"
import style0 from "./LicentieKopen.vue?vue&type=style&index=0&id=3fd357be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd357be",
  null
  
)

export default component.exports